import React from "react";
import { Link } from "react-router-dom";
import styles from "./NotFoundPage.module.css";

export default function NotFoundPage() {
  return (
    <div className={styles.wrap}>
      <div className={styles.card}>
        <span className={styles.kicker}>404</span>
        <h1>Page not found</h1>
        <p>
          The page you tried to open does not exist, moved, or is temporarily unavailable.
        </p>
        <div className={styles.actions}>
          <Link to="/" className="btnBase btnPrimary">
            Go home
          </Link>
          <Link to="/auth/admin/login" className="btnBase btnSecondary">
            Admin login
          </Link>
        </div>
      </div>
    </div>
  );
}
